import { useState } from '@/runtime';
export function usePwa() {
  const installEvent = useState<{ prompt: () => Promise<void> } | null>('pwa-install-event', () => null);
  const updateReady = useState<boolean>('pwa-update-ready', () => false);
  async function install() {
    try { await installEvent.value?.prompt(); } catch { /* диалог отклонён */ }
    installEvent.value = null;
  }
  async function applyUpdate() {
    const registration = await navigator.serviceWorker.getRegistration();
    registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });
    window.setTimeout(() => window.location.reload(), 800);
  }
  return { installEvent, updateReady, install, applyUpdate };
}
